module.exports = __webpack_public_path__ + "img/teacher.1339c537.png";